// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:42:44

export default {
  "id": "unlock-the-bolts",
  "slug": "unlock-the-bolts",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/689cb6438daf4299b8c2915adc2955ed-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/689cb6438daf4299b8c2915adc2955ed/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Unlock the Bolts",
      "description": "Unlock the Bolts is a challenging puzzle game where you carefully remove screws to solve mechanical puzzles. Each level tests your logic and precision as you figure out the correct order to unlock the bolts. In special levels, the stakes are even higher—you must free trapped animals by unlocking the right bolts! With satisfying mechanics and engaging challenges, this game will keep you thinking and entertained. Can you master every puzzle and rescue the animals in need?",
      "instructions": "Follow the game instructions!",
      "genres": [
        "Puzzle",
        "Strategy"
      ],
      "tags": [
        "3d",
        "animal",
        "arcade",
        "physics",
        "rescue"
      ]
    },
    "zh-CN": {
      "title": "解锁螺栓",
      "description": "《解锁螺栓》是一款挑战性解谜游戏，您需要小心地移除螺丝来解决机械谜题。每个关卡都考验您的逻辑和精确度，以找出解锁螺栓的正确顺序。在特殊关卡中，赌注更高——您必须通过解锁正确的螺栓来释放被困的动物！凭借令人满意的机制和引人入胜的挑战，这款游戏将让您持续思考并享受乐趣。您能精通所有谜题并拯救需要帮助的动物吗？",
      "instructions": "遵循游戏说明！",
      "genres": [
        "拼图",
        "策略"
      ],
      "tags": [
        "3D",
        "动物",
        "街机",
        "物理",
        "救援"
      ]
    },
    "zh-TW": {
      "title": "解開螺栓",
      "description": "解開螺絲是一款挑戰性的謎題遊戲，你必須仔細移除螺絲來解開機械謎題。每個關卡都會考驗你的邏輯和精準度，讓你找出解鎖螺絲的正確順序。在特殊關卡中，賭注更高——你必須解鎖正確的螺絲來釋放被困的動物！這款遊戲具有令人滿意的機制和引人入勝的挑戰，將讓你保持思考並享受樂趣。你能夠解開所有謎題並拯救需要的動物嗎？",
      "instructions": "依照遊戲指示進行！",
      "genres": [
        "謎題",
        "策略"
      ],
      "tags": [
        "3D",
        "動物",
        "街機",
        "物理",
        "救援"
      ]
    },
    "zh-HK": {
      "title": "解鎖螺栓",
      "description": "解開螺絲是一個挑戰性強的謎題遊戲，你需小心翼翼地移除螺絲來解開機械謎題。每個關卡都會考驗你的邏輯和精準度，當你找出解鎖螺絲的正確順序。在特別關卡中，賭注更高——你必須解鎖正確的螺絲來釋放被困的動物！這款遊戲擁有令人滿意的機制和引人入勝的挑戰，將讓你保持思考並樂在其中。你能夠掌握每一個謎題並拯救需要幫助的動物嗎？",
      "instructions": "依照遊戲指示進行！",
      "genres": [
        "謎題",
        "策略"
      ],
      "tags": [
        "3D",
        "動物",
        "街機",
        "物理",
        "救援"
      ]
    },
    "ja": {
      "title": "ボルトを解錠する",
      "description": "「ボルトを解き放つ」は、慎重にボルトを外して機械的なパズルを解く挑戦的なパズルゲームです。各レベルであなたの論理と正確さを試され、ボルトを解錠する正しい順番を見つけることが求められます。特別なレベルでは、リスクがさらに高まり、正しいボルトを解錠して捕らえられた動物を解放する必要があります！満足のいくメカニクスと魅力的な挑戦で、このゲームはあなたを考えるようにし、楽しませます。すべてのパズルをマスターし、必要な動物を救出できるでしょうか？",
      "instructions": "ゲームの説明に従ってください！",
      "genres": [
        "パズル",
        "戦略"
      ],
      "tags": [
        "3D",
        "動物",
        "アーケード",
        "物理",
        "救助"
      ]
    },
    "ko": {
      "title": "버릇을 풀어라",
      "description": "불림을 풀다는 게임은 정교하게 스크루를 제거하여 기계적 퍼즐을 해결하는 도전적인 퍼즐 게임입니다. 각 레벨은 당신의 논리와 정밀성을 테스트하며, 완벽한 순서를 찾아 불림을 풀어야 합니다. 특별한 레벨에서는 위험도가 더 높아지며 — 올바른 불림을 풀어 갇힌 동물을 해방해야 합니다! 만족스러운 기계적 원리와 흥미로운 도전으로, 이 게임은 당신을 깨우침과 즐거움으로 가득 채워줍니다. 모든 퍼즐을 마스터하고 필요한 동물을 구할 수 있을까요?",
      "instructions": "게임 지시를 따르세요!",
      "genres": [
        "퍼즐",
        "전략"
      ],
      "tags": [
        "3D",
        "동물",
        "아케이드",
        "물리학",
        "구조"
      ]
    },
    "fr": {
      "title": "Désbloquez les écrous",
      "description": "Désenclenchez les Vis est un jeu de puzzle stimulant où vous retirez soigneusement les vis pour résoudre des puzzles mécaniques. Chaque niveau teste votre logique et votre précision alors que vous découvrez l'ordre correct pour déverrouiller les vis. Dans les niveaux spéciaux, les stakes sont encore plus élevées - vous devez libérer des animaux prisonniers en déverrouillant les bonnes vis ! Avec des mécanismes satisfaisants et des défis captivants, ce jeu vous gardera en haleine et amusé. Pouvez-vous maîtriser chaque puzzle et sauver les animaux en détresse ?",
      "instructions": "Suivez les instructions du jeu !",
      "genres": [
        "Puzzle",
        "Stratégie"
      ],
      "tags": [
        "3D",
        "animal",
        "arcade",
        "physique",
        "sauvetage"
      ]
    }
  }
};
